import React from 'react'
import styles from '../styles/Global';
import assets from '../assets';

const Download = () => {
  return (
    <div className={`${styles.section} ${styles.bgWhite}`} >
      <div className={`${styles.subSection} flex-col text-center`}>
          <div>
            <h1 className={`${styles.h1Text} ${styles.blackText}`}>Dowload the APK file</h1>            
          </div>
          <a className={`${styles.btnPrimary}`} href="https://expo.dev/artifacts/eas/sXDDVvzzYybcdfAVX16jAS.apk">Download APK</a>
          <div className={`${styles.flexCenter}`}>
            <img src={assets.scene} alt="download" className={styles.fullImg} />
          </div>
      </div>
    </div>
  )
}

export default Download